/* eslint-disable boundaries/dependencies */ import React, { createContext, useContext, useState } from 'react';
import { getHomepageUrl, navigateToPage } from '../../../../../code/client/shared/scripts/ui_utils/ClientUtils.ts';
import { showSimpleDialog } from '../../../../../code/client/shared/scripts/ui_popup/showSimpleDialog.ts';
import { FeedbackFormUtils } from '../../../../../code/client/shared/scripts/ui_popup/ui_popup_feedback_form/FeedbackFormUtils.ts';
import { showFeedbackForm } from '../../../../../code/client/shared/scripts/ui_popup/ui_popup_feedback_form/showFeedbackForm.ts';
import { FeedbackFormLocationEnum } from '../../../../../code/shared/entity_datas/EntityDatas.ts';
import { socket, uiManagerEvents } from '../../../../../code/client/shared/scripts/EntryShared.ts';
import { UIUrlParameterNames } from '../../../../../code/client/shared/scripts/ui_html/UIUrlController.ts';
import { UIEntryUrlParameterController } from '../../../../../code/client/shared/scripts/UIEntryUrlParameterController.ts';
import { useGameStore } from '../../store/GameStoreContext.ts';
export const UIGameHelpLeaveGameContext = /*#__PURE__*/ createContext(undefined);
export const useUIGameHelpLeaveGameContext = ()=>{
    const context = useContext(UIGameHelpLeaveGameContext);
    if (!context) throw new Error('useUIGameHelpLeaveGameContext must be used within a UIGameHelpLeaveGameProvider');
    return context;
};
let globalSetCanResign;
export const setGlobalCanResign = (canResign)=>{
    if (globalSetCanResign) globalSetCanResign(canResign);
};
export const UIGameHelpLeaveGameProvider = ({ children, initialCanResign })=>{
    const [canResign, setCanResign] = useState(initialCanResign);
    const { sendLeaveGame, sendResignGame } = useGameStore((state)=>state.gameSendEvent);
    const isMyColorSpectator = useGameStore((state)=>state.isMyColorSpectator);
    globalSetCanResign = setCanResign;
    const leaveGame = ()=>{
        const isViewingReplayOnProfilePage = window.location.href.includes('/profile');
        if (isViewingReplayOnProfilePage) {
            location.reload();
            return;
        }
        if (canResign) {
            createResignGamePopup();
            return;
        }
        createStandardLeaveGamePopup();
    };
    const createStandardLeaveGamePopup = ()=>{
        const title = {
            key: 'strings:game.leaveGame.title'
        };
        const body = {
            key: 'strings:game.leaveGame.body'
        };
        const leaveGameAction = ()=>showPopupsBeforeExitingGame(()=>{
                sendLeaveGame();
                if (isMyColorSpectator) {
                    uiManagerEvents.handleUrlRedirectViaParameters(UIUrlParameterNames.Spectate, UIEntryUrlParameterController.DEFAULT_PARAMETER_VALUE);
                    return;
                }
                navigateToPage(getHomepageUrl());
            });
        showSimpleDialog({
            title: title,
            body: body,
            onConfirm: leaveGameAction,
            showCancelBtn: true
        });
    };
    const createResignGamePopup = ()=>{
        const title = {
            key: 'strings:game.resign.title'
        };
        const body = {
            key: 'strings:game.resign.body'
        };
        const resignAction = ()=>showPopupsBeforeExitingGame(()=>sendResignGame());
        showSimpleDialog({
            title: title,
            body: body,
            onConfirm: resignAction,
            confirmLabel: {
                key: 'strings:game.resign.title'
            },
            showCancelBtn: true
        });
    };
    const showPopupsBeforeExitingGame = (continuationAction)=>{
        const shouldShowFeedbackForm = FeedbackFormUtils.shouldShowFeedbackForm();
        if (shouldShowFeedbackForm == true) {
            showFeedbackForm(socket.gameListener.databaseGameId, FeedbackFormLocationEnum.QuitGame, continuationAction);
            return;
        }
        continuationAction();
    };
    return /*#__PURE__*/ React.createElement(UIGameHelpLeaveGameContext.Provider, {
        value: {
            canResign: canResign,
            leaveGame: leaveGame
        }
    }, children);
};
